import { getPagination } from '@deque/pagination-utils';
import { useCallback } from 'react';
import useAPI from '~/common/hooks/useAPI';
import {
  getSecurityEventLog,
  type SecurityEvent,
  type SecurityEventLogParams
} from '~/common/utils/admin-client/get-security-event-log';

interface UseSecurityEventLogProps extends SecurityEventLogParams {
  token: string;
  enterpriseId: string | null;
}

interface UseSecurityEventLogResponse {
  events: SecurityEvent[];
  totalItems: number;
  loading: boolean;
  error: Error | null;
  refresh: () => void;
}

export const useSecurityEventLog = ({
  token,
  enterpriseId,
  start_date,
  end_date,
  user_id,
  event_type,
  category,
  admin_only,
  page,
  per_page
}: UseSecurityEventLogProps): UseSecurityEventLogResponse => {
  const dataLoader = useCallback(
    () =>
      getSecurityEventLog({
        token,
        enterpriseId,
        start_date,
        end_date,
        user_id,
        event_type,
        category,
        admin_only,
        page,
        per_page
      }),
    [
      token,
      enterpriseId,
      start_date,
      end_date,
      user_id,
      event_type,
      category,
      admin_only,
      page,
      per_page
    ]
  );

  const { data, loading, error, refresh } = useAPI(dataLoader);

  return {
    events: data ?? [],
    totalItems: (data && getPagination(data))?.total ?? 0,
    loading,
    error,
    refresh
  };
};
